import React, { useState } from 'react';
import styles from './Login.module.css';

interface LoginProps {
  onLoginSuccess: (auth: { access_token: string; id_token?: string; expires_in: number; token_type: string }) => void;
}

const AUTH0_DOMAIN = "progentec-dev.us.auth0.com";
const AUTH0_CLIENT_ID = "jFgbWBNEPNxqZ8ajWh3M1IRpVpq2JTh0";
const AUTH0_AUDIENCE = "https://progentec-dev.us.auth0.com/api/v2/"

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`https://${AUTH0_DOMAIN}/oauth/token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          grant_type: 'http://auth0.com/oauth/grant-type/password-realm',
          username: email,
          password,
          audience: AUTH0_AUDIENCE,
          scope: 'openid profile email',
          client_id: AUTH0_CLIENT_ID,
          realm: 'Username-Password-Authentication',
        }),
      });
      let data: any = {};
      try {
        data = await response.json();
      } catch {}
      if (!response.ok) {
        setError(data.error_description || data.error || 'Login failed. Please check your credentials and try again.');
        setLoading(false);
        return;
      }
      // Store tokens in localStorage
      localStorage.setItem('access_token', data.access_token);
      if (data.id_token) localStorage.setItem('id_token', data.id_token);
      localStorage.setItem('expires_in', (Date.now() + data.expires_in * 1000).toString());
      onLoginSuccess(data);
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <form onSubmit={handleSubmit} className={styles.loginForm}>
        <img src="/app_logo.png" alt="App Logo" className={styles.loginLogo} />
        {error && (
          <div className={styles.loginError}>{error}</div>
        )}
        <div className={styles.loginFieldWrapper}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className={styles.loginInput}
          />
          <div className={styles.passwordInputWrapper}>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className={styles.loginInput + ' ' + styles.loginInputPassword}
            />
            <button
              type="button"
              className={styles.eyeButton}
              onClick={e => { e.preventDefault(); setShowPassword(v => !v); }}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {!showPassword ? (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1976d2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12C1 12 5 5 12 5s11 7 11 7-4 7-11 7S1 12 1 12z"/><circle cx="12" cy="12" r="3"/></svg>
              ) : (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#1976d2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="12" rx="10" ry="6"/><line x1="6" y1="16" x2="5" y2="18"/><line x1="9" y1="17" x2="8.5" y2="19"/><line x1="12" y1="18" x2="12" y2="20"/><line x1="15" y1="17" x2="15.5" y2="19"/><line x1="18" y1="16" x2="19" y2="18"/></svg>
              )}
            </button>
          </div>
        </div>
        <button type="submit" disabled={loading} className={styles.loginButton}>
          {loading ? 'Logging in...' : 'Log In'}
        </button>
      </form>
    </div>
  );
};

export default Login; 